import {ElementRef, Injectable, Injector, Renderer2, RendererFactory2, runInInjectionContext} from "@angular/core";
import {CdkScrollable, ScrollDispatcher} from "@angular/cdk/scrolling";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('CdkScrollableSomTjeneste');

/** Tjeneste som gjør det mulig å registrere skrollkontainere definert i ajs-kode i ng2s {@link ScrollDispatcher} tjeneste slik at bla
 * OverlayConfig.scrollStrategy skal fungere som forventet. */
@Injectable({providedIn: 'root'})
export class CdkScrollableSomTjeneste {

    constructor(private rendererFactory: RendererFactory2, private injector: Injector) {
    }

    /** Registrerer et element som skrollbart i ng2-tjenesten {@link ScrollDispatcher}.
     * MERK at kaller er ansvarlig for at {@link CdkScrollable#ngOnDestroy()} blir kalt på returnert {@link CdkScrollable}
     * når angitt element blir fjernet fra DOM. */
    registrerElementSomSkrollbart(element: HTMLElement): CdkScrollable {
        debug('registrerElementSomSkrollbart kalt med element', element);
        //lage en ny injektor tilbyr vårt 'element'

        const injektorMedElementRef = Injector.create({
            providers: [
                //sørger for å gjøre 'element' tilgjengelig for CdkScrollable, CdkScrollable bruker inject(ElementRef) i sin konstruktør
                {provide: ElementRef, useValue: new ElementRef<HTMLElement>(element)},
                //CdkScrollable kaller Renderer2.listen for å lytte til scroll-eventer - Renderer2 er ikke tilgjengelig i rot-injektoren - legger derfor til en instans her
                {provide: Renderer2, useValue: this.rendererFactory.createRenderer(null, null)},
            ],
            parent: this.injector
        });
        return runInInjectionContext(injektorMedElementRef, () => new CdkScrollable())
    }
}
